const SEO = [
	{
		page: "home",
		description:
			"Hi, I'm Daphne — a full-stack developer in Kampala, Uganda. I build websites and mobile apps that help people, across finance and healthcare.",
		keywords: [
			"Naggayi Daphne Pearl",
			"Full-stack developer",
			"React Native developer",
			"Software engineer Uganda",
		],
	},

	{
		page: "about",
		description:
			"A little about Daphne Pearl — a developer in Kampala who has spent three years building apps people rely on every day in finance and healthcare.",
		keywords: [
			"Naggayi Daphne Pearl",
			"Full-stack engineer",
			"Telemedicine developer",
		],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Naggayi Daphne Pearl", "Naggayi Daphne Pearl", "Naggayi Daphne Pearl"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Naggayi Daphne Pearl", "Naggayi Daphne Pearl", "Naggayi Daphne Pearl"],
	},
];

export default SEO;
